var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DatePicker,_vm._g(_vm._b({staticClass:"pg-date-picker",attrs:{"size":_vm.size,"format":_vm.format,"value-format":_vm.format}},'DatePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }